import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["name", "quantity", "sku"];

  connect() {
    this.updateProfile();
    console.log('inventory profile connected');
  }

  updateProfile() {
    const name = this.element.querySelector('input[name="inventory[name]"]').value;
    const quantity = this.element.querySelector('input[name="inventory[quantity]"]').value;
    const sku = this.element.querySelector('input[name="inventory[sku]"]').value;

    this.nameTarget.textContent = name;
    this.quantityTarget.textContent = quantity;
    this.skuTarget.textContent = sku;
  }
}
